/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { uGrid as d, classNames as t } from "@progress/kendo-react-common";
const c = (s) => {
  const { colSpan: e, ariaColIndex: l, unstyled: r } = s, o = r && r.uGrid ? r.uGrid : d;
  return { tdProps: {
    className: t(o.detailTd({})),
    colSpan: e,
    "aria-colindex": l,
    role: "gridcell"
  } };
};
export {
  c as getDetailCellTdProps
};
